let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gQSgL")).then(() => parcelRequire('3C717'));